module.exports = __webpack_public_path__ + "img/magento-version-switching_small.ee9dd150.jpg";